export const Props = () => ({
  //Использовать адаптивный формат?
  isAdaptive: { type: Boolean },
});